<template>
<div class="container-footer">
    <div>Copyright © Antoine Poirrier. Tout droits réservés</div>
</div>
    
</template>

<script>
export default {
    name:'Footer'
}
</script>


<style scoped>

.container-footer {
    padding: 0.5rem;
    background-color: #343a40!important;
    display: flex;
    justify-content: center;
}

.container-footer div {

    font-family: Arial, Helvetica, sans-serif;
    color: white;
}

</style>